import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FormatAddressString } from "go-core/components/Formatters/FormatAddress";
import { BasicPartnerApi, PartnerApi } from "../../../../../../../services/Api/Partner/partnerTypes";

interface Props {
	partner: PartnerApi;
}

const PartnerCard = ({ partner }: Props) => {
	const { t } = useTranslation("admin");

	const address = {
		street: partner.company_street,
		build_nr: partner.company_build_nr,
		flat_nr: partner.company_flat_nr,
		zip_code: partner.company_zip_code,
		city: partner.company_city,
	};

	const renderParentName = (parent: BasicPartnerApi) => {
		if (parent && parent.name) return parent.name;
		return "GoPOS";
	};

	const getBadgeColor = (parent: BasicPartnerApi) => {
		if (parent && parent.name) return "bg-danger";
		return "bg-primary";
	};

	return (
		<div className="col-md-4 mb-3">
			<Card className="h-100 card-partner">
				<Card.Body className="position-relative">
					<Card.Title>
						<div className="d-flex flex-wrap gap-2">
							{partner.name}
							<span
								className={`badge ${getBadgeColor(partner.parent)}`}
								style={{ fontSize: "12px", verticalAlign: "middle", textWrap: "wrap" }}
							>
								{renderParentName(partner.parent)}
							</span>
						</div>
					</Card.Title>
					<div className={"d-flex flex-column"}>
						{partner.company_name && (
							<div>
								<span className="label">{t("common.word.company_name")}: </span>
								<span className="label-info">{partner.company_name}</span>
							</div>
						)}
						{partner.company_tax_id_no && (
							<div>
								<span className="label">{t("lib:common.word.tax_id_no.title")}: </span>
								<span className="label-info">{partner.company_tax_id_no}</span>
							</div>
						)}
						{address && Object.keys(address).length > 0 && Object.values(address).some((s) => s) && (
							<div>
								<span className="label">{t("lib:common.word.address")}: </span>
								<span className={"label-info"}>{FormatAddressString(address)}</span>
							</div>
						)}
					</div>
					<Card.Link className="stretched-link" as={Link} to={`/partnership/${partner.id}`} />
				</Card.Body>
			</Card>
		</div>
	);
};
export default PartnerCard;
